//
import Content from './Content';
import LowerContent from './LowerContent';
import Subject from './Subject';

/**
 *
 */
function Body({ preview }) {
  return (
    <div style={BodyStyle}>
      <Subject preview={preview} />
      <Content preview={preview} />
      <LowerContent preview={preview} />
    </div>
  );
}

export default Body;

const BodyStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};
